import AsyncStorage from "@react-native-async-storage/async-storage";

export const FIREBASE_ANALYTICS_QUEUE_STORAGE_KEY =
  "firebase_analytics_call_queue";

export const FIREBASE_ANALYTICS_CALL_TYPE = {
  LOG_EVENT: "logEvent",
  SET_USER_ID: "setUserId"
};

export class FirebaseAnalyticsCallQueue {
  async read() {
    try {
      const raw = await AsyncStorage.getItem(
        FIREBASE_ANALYTICS_QUEUE_STORAGE_KEY
      );
      const parsed = raw ? JSON.parse(raw) : [];

      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  async add(call) {
    const calls = await this.read();
    calls.push(call);
    await AsyncStorage.setItem(
      FIREBASE_ANALYTICS_QUEUE_STORAGE_KEY,
      JSON.stringify(calls)
    );
  }

  async clear() {
    await AsyncStorage.removeItem(FIREBASE_ANALYTICS_QUEUE_STORAGE_KEY);
  }
}
